import { useFeedback, useTranslation } from "@opendash/core";
import { stringToTag } from "@opendash/ui";
import { Button, Form, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo, useState } from "react";
import { saveTicket, useTicketData } from "../..";
import { SelectUsersAndRoles } from "../../../../_shared";
import { SaveTicketValuesWithFullMeta } from "../../creation/types/SaveTicketValues";

export const AssignUserModal = observer(
  (props: { open: boolean; onCancel: Function; onOk: Function }) => {
    const t = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const ticketData = useTicketData();
    const { handleLoadingFeedback } = useFeedback();

    const assignedUsers = useMemo(
      () => ticketData.assignedTo.filter((a) => a.className === "_User"),
      [ticketData.assignedTo]
    );

    const assignedRoles = useMemo(
      () => ticketData.assignedTo.filter((a) => a.className === "_Role"),
      [ticketData.assignedTo]
    );

    const save = async () => {
      form
        .validateFields()
        .then(async (formvalues: { usersorroles: string[] }) => {
          setLoading(true);

          try {
            const saveValues: SaveTicketValuesWithFullMeta = {
              existingTicketId: ticketData.ticket.id,
              assignedTo: formvalues.usersorroles.map((prefixid) => {
                const prefixIdArray = prefixid.split("_");
                return {
                  type: prefixIdArray[0] as "user" | "role",
                  id: prefixIdArray[1],
                };
              }),
            };

            await handleLoadingFeedback(
              () => saveTicket(saveValues),
              t("maintenance:ticket.assignment.loading"),
              t("maintenance:ticket.assignment.success"),
              t("maintenance:ticket.assignment.error")
            );

            props.onOk(formvalues.usersorroles);
          } catch (e) {
            console.error(e);
          }
          setLoading(false);
        });
    };

    const title = stringToTag(
      t("maintenance:ticket.assignuser.headline", {
        ticket: ticketData.ticket?.get("title"),
      }),
      "'"
    );

    return (
      <Modal
        forceRender
        getContainer={false}
        title={title}
        open={props.open}
        onOk={save}
        onCancel={() => {
          props.onCancel();
        }}
        width={"80%"}
        footer={[
          <Button
            key="back"
            onClick={() => {
              props.onCancel();
            }}
          >
            {t("maintenance:global.button.cancel_label")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={save}
            disabled={!ticketData.ticket}
          >
            {t("maintenance:global.button.save_label")}
          </Button>,
        ]}
      >
        <Form autoComplete="off" form={form} layout="vertical">
          <SelectUsersAndRoles
            initialUsers={assignedUsers}
            initialRoles={assignedRoles}
            onCancel={props.onCancel}
            onOk={props.onOk}
          />
        </Form>
      </Modal>
    );
  }
);
